import { Injectable } from '@angular/core';
import { Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Reservation } from '../models/reservation';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { EventReservationSource } from '../models/event-reservation-source';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { Page } from '../../shared/models/page';
import { ReservationStatusCode } from '../models/reservation-status-code.enum';

@Injectable()
export class ReservationService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  get(eventId: number): Observable<List<Reservation> | Response> {
    const reservationUrl = `${this.eventUrl}/${eventId}/reservations/consumed`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<Reservation>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  add(reservation: Reservation, source: EventReservationSource): Observable<any> {
    let result;
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const reservationAsJSON = JSON.stringify(reservation.toJS());
    let endpoint;
    switch (source) {
      case EventReservationSource.MANUAL:
        endpoint = `${this.eventUrl}/reservations/add`;
        break;
      case EventReservationSource.RSVP:
        endpoint = `${this.eventUrl}/reservations/from-rsvp/add`;
        break;
      default:
        break;
    }
    if (!endpoint) {
      result = Observable.throw('The source received (' + source + ') is not supported.');
    } else {
      result = this.http.post(endpoint, reservationAsJSON, options)
        .catch(response => this.responseUtilService.handleError(response))
        .share();
    }
    return result;
  }

  delete(reservation: Reservation): Observable<any> {
    return this.http.delete(`${this.eventUrl}/reservations/${reservation.eventReservationId}`)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  update(reservation: Reservation): Observable<any> {
    let result;
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const reservationAsJSON = JSON.stringify(reservation.toJS());
    result = this.http.put(`${this.eventUrl}/reservations/`, reservationAsJSON, options)
      .catch(response => this.responseUtilService.handleError(response)).share();
    return result;
  }

  importReservationFile(eventId: number, file: File): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.eventUrl}/${eventId}/reservations/import`, formData)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getReservationsByStatus(eventId: number, statusCodes: ReservationStatusCode[], page: number, size: number)
  : Observable<Page<Reservation> | Response> {
    const url = `${this.eventUrl}/${eventId}/reservations-by-status?page=${page}&size=${size}`;
    const request = {
      eventId: eventId,
      statusCodes: Array.from(statusCodes)
    };
    return this.httpPost(url, request).map(reservationPage => {
      reservationPage.content = List<Reservation>(reservationPage.content);
      return reservationPage as Page<Reservation>;
    });
  }

  private httpPost(url: string, request: any): Observable<any> {
    const options = new RequestOptions({ headers: new Headers({ 'Content-Type': 'application/json' }) });
    return this.http.post(url, JSON.stringify(request), options)
      .map(response => response.json())
      .catch(error => this.responseUtilService.handleError(error))
      .share();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/reservation-http-service.ts